import React from 'react';
import logo from './logo.png';
import './SplashScreen.css';
import { Flex, Heading, Container } from '@radix-ui/themes';

interface SplashScreenProps {
    isDarkTheme: boolean;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ isDarkTheme }) => (
    <Container size="4" className={`splash-screen ${isDarkTheme ? 'dark-theme' : 'light-theme'}`}>
        <Flex direction="column" align="center" justify="center" gap="6" style={{ height: '100vh' }}>
            <img src={logo} className="splash-logo" alt="Wado Kai Karate Logo" />
            <Heading size="8" align="center" className="splash-title">
                Wado Kai Karate-Ka Space
            </Heading>
        </Flex>
    </Container>
);

export default SplashScreen; 